<template>
  <modal name="invoice-check-modal"
         :width="600"
         :height="`auto`"
         :pivotX="0.5"
         :pivotY="0.5"
         :delay="100"
         :reset="true"
         @before-open="beforeOpen"
  >
    <div class="FloatMenu md_overlay md_overlay_0 ">
      <div class="modal modal_0">
        <div class="md_content md_type2">
          <div class="popup_title">
            Invoice
          </div>
          <span class="md_close">
                  <img src="/images/union.svg"
                       @click="modalClose"
                       alt=""
                  />
          </span>
          <div class="title_desc">Thank you so much :)</div>
          <LeftHeaderTable
              :items="computedItems"
              class="mt30 mb10"
          />
        </div>
      </div>
    </div>
  </modal>
</template>
<script>
import LeftHeaderTable from '@/components/Table/leftHeaderTable';

export default {
  name: 'InvoiceCheckModal',
  components: {
    LeftHeaderTable
  },
  data() {
    return {
      invoiceDetails: {}
    }
  },
  computed: {
    computedItems() {
      const items = [];
      const billingDate = this.moment(this.invoiceDetails.billingDate).locale(this.$t('country')).format('ll');
      const expirationDate = this.moment(this.invoiceDetails.expirationDate).locale(this.$t('country')).format('ll');

      items.push({title: 'Receiver', content: this.invoiceDetails.email || '-'});
      items.push({title: 'Payment date', content: billingDate});
      items.push({title: 'Charged to', content: `${this.invoiceDetails.cardType} ${this.$t('my.payment.details.card')}`});
      items.push({title: 'For service through', content: expirationDate});
      items.push({
        title: 'Description',
        content: `${this.invoiceDetails.baseProductInfo?.defaultProductTitle}(${this.invoiceDetails.baseProductInfo?.defaultProductSubTitle})`
      });
      items.push({
        title: 'Price',
        content: `${this.invoiceDetails.amount} ${this.invoiceDetails.baseProductInfo?.productAmountUnit}`,
        type: 'right'
      });
      items.push({
        title: 'Total Charged',
        content: `${this.invoiceDetails.amount} ${this.invoiceDetails.baseProductInfo?.productAmountUnit}`,
        type: 'right'
      });

      return items
    }
  },
  methods: {
    modalClose: function () {
      this.$modal.hide('invoice-check-modal');
    },
    beforeOpen(event) {
      this.invoiceDetails = event.params;
    }
  }
}
</script>
